import React from "react";
import { ShieldCheck, Briefcase, Handshake, Eye, Landmark } from "lucide-react";

const OFFICE =
  "https://images.unsplash.com/photo-1554469384-e58fac16e23a?auto=format&fit=crop&w=1400&q=80";
const OFFICE_2 =
  "https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1400&q=80";

const pillars = [
  { icon: ShieldCheck, label: "Segurança no negócio" },
  { icon: Briefcase, label: "Estrutura profissional" },
  { icon: Handshake, label: "Atendimento consultivo" },
  { icon: Landmark, label: "Tradição e experiência" },
  { icon: Eye, label: "Transparência operacional" },
];

export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative bg-[#05070D] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Left — copy */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <div className="gold-line" />
              <span className="overline">Sobre a ASHIR GROUP</span>
            </div>

            <h2 className="font-serif-ag text-white text-4xl md:text-5xl lg:text-[3.5rem] font-light leading-[1.05] tracking-[-0.015em]">
              Excelência na estruturação de{" "}
              <span className="text-[#D4AF37] italic">capital inteligente</span>{" "}
              para projetos de alto valor.
            </h2>

            <div className="mt-10 space-y-6 text-[#A3ABB8] text-base md:text-lg font-light leading-relaxed max-w-2xl">
              <p>
                A <span className="text-white">ASHIR GROUP</span> atua com excelência
                na estruturação e comercialização de cartas de consórcio
                contempladas, oferecendo soluções estratégicas para capital de
                giro, expansão empresarial, reforço de caixa e aquisição
                patrimonial.
              </p>
              <p>
                Com experiência de mercado, atuação profissional e atendimento
                consultivo, entregamos segurança jurídica, agilidade operacional
                e oportunidades diferenciadas para clientes que buscam crédito
                inteligente — sem os juros abusivos do mercado tradicional.
              </p>
            </div>

            {/* Pillars */}
            <ul className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-5">
              {pillars.map((p, i) => (
                <li
                  key={i}
                  data-testid={`about-pillar-${i}`}
                  className="flex items-center gap-4 border-b border-white/5 pb-4"
                >
                  <p.icon size={18} strokeWidth={1.3} className="text-[#D4AF37]" />
                  <span className="text-[13px] md:text-sm tracking-[0.05em] text-white font-light">
                    {p.label}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right — imagery */}
          <div className="lg:col-span-5 lg:pl-6">
            <div className="relative">
              <div className="absolute -top-4 -left-4 right-8 bottom-8 border border-[#D4AF37]/30" />
              <img
                src={OFFICE}
                alt="Ambiente corporativo ASHIR GROUP"
                className="relative w-full aspect-[4/5] object-cover grayscale-[15%]"
                data-testid="about-image-main"
              />
              <img
                src={OFFICE_2}
                alt="Reunião executiva"
                className="hidden md:block absolute -bottom-12 -right-6 w-48 h-60 object-cover border-4 border-[#05070D] shadow-2xl"
                data-testid="about-image-secondary"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
